import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as googleSearchActions from './google-search.actions';

@Injectable({
	providedIn: 'root',
})
export class GoogleSearchDispatch {
	@Dispatch()
	GoogleSearchConnect = (): googleSearchActions.Connect =>
		new googleSearchActions.Connect();
}
